import '@fortawesome/fontawesome-free/css/all.css'
import Vue from 'vue'

import './plugins'

import './components/core'

import App from './App.vue'
import router from './router'
import store from './store/index'
import './utils/filters'
import './mixins/index'
import { auth } from '@/store/firebase'
import moment from 'moment-timezone'
import 'moment/locale/pt-br'

Vue.config.productionTip = false

moment.locale('pt-br')
moment.tz.setDefault('America/Sao_Paulo')
Vue.prototype.$moment = moment

let app

auth.onAuthStateChanged(user => {
  if (!app) {
    app = new Vue({
      router,
      store,
      render: h => h(App)
    }).$mount('#app')
  }
})
